import { component } from 'picoapp'
import { formatMoney } from '@/lib/currency.js'
import { image } from '@/lib/utils/image'
import { addItemById } from '@/lib/cart'

export default component((node, ctx) => {
    const initUpsell = () => {
        const items = node.querySelector('[data-upsell-items]')
        const productIds = ctx
            .getState()
            .cart.items.slice(0, 10)
            .map((item) => item.variant_id)
            .join(',')

        items.innerHTML = ''

    
    }

    initUpsell()

    ctx.on('cart:updated', () => {
        initUpsell()
    })
})
